



































import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import dayjs from 'dayjs'
import { filter, sort, map } from 'ramda'
import {
  update, field, collection, get, query, where, set, add,
} from 'typesaurus'
import {
  getModule,
} from 'vuex-module-decorators'
import { VueEditor } from 'vue2-editor'
import { InfoBoardType } from '../../types'
import { db } from '../../firebase/init'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'
import CardList from '../../components/layout/CardList.vue'
import InfoBoardsStore from '../../store/modules/infoBoards'

const infoBoard = collection<InfoBoardType>('infoBoards')

@Component({
  components: {
    CardList,
    VueEditor,
  },
})

export default class ManageInfoBoards<T extends Vue> extends Mixins(MainMixin) {
  tabs = [{ title: 'Daily', value: 'daily', name: 'Daily Info' }, { title: 'FoH', value: 'foh', name: 'Front Of House Info' }, { title: 'BoH', value: 'boh', name: 'Back of House Info' }, { title: 'Management', value: 'management', name: 'Management Info' }, { title: 'Handbook', value: 'handbook', name: 'Employee Handbook' }]

  weekdays = [{ text: 'Sunday', value: 0 }, { text: 'Monday', value: 1 }, { text: 'Tuesday', value: 2 }, { text: 'Wednesday', value: 3 }, { text: 'Thursday', value: 4 }, { text: 'Friday', value: 5 }, { text: 'Saturday', value: 6 }, { text: 'All Days', value: 7 }]

  activeBoard = ''

  get activeBoardData() {
    if (!this.activeBoard) {
      return { id: null }
    }
    return this.allBoards.find((board:InfoBoardType) => board.id === this.activeBoard)
  }

  activeText = ''

  loading = false

  showNewDialog = false

  isGroup = false

  newBoard:InfoBoardType = {
    name: '', description: '', location: '', category: '', text: '', updated: new Date(),
  }

  saveBoard() {
    this.loading = true
  }

  clearDialog() {
    this.newBoard = {
      name: '', description: '', text: '', category: '', updated: new Date(),
    }
  }

  InfoBoards:any = getModule(InfoBoardsStore)

  get allBoards() {
    return this.InfoBoards.allBoards
  }

  boardItems(tab:string) {
    const inCategory = ((board:any) => board.category === tab)
    const mapBoard = ((board:any) => ({ text: board.name, value: board.id }))
    const sortBoard = ((a:any, b:any) => (a.text > b.text ? 1 : -1))
    return sort(sortBoard, map(mapBoard, filter(inCategory, this.allBoards)))
  }

  async createBoard() {
    if (!this.newBoard.name || !this.newBoard.description) return false
    this.loading = true
    const newBoard:InfoBoardType = {
      name: this.newBoard.name,
      text: '',
      location: this.isGroup ? this.group : this.location,
      description: this.newBoard.description,
      category: this.activeTab,
      updated: new Date(),
      updatedBy: this.uid,
    }
    await add(infoBoard, newBoard)
    this.loading = false
    this.showNewDialog = false
    this.isGroup = false
    this.$toast.success(`Board ${newBoard.name} Successfully Created.`)
    return this.clearDialog()
  }

  async updateBoard() {
    if (!this.activeBoardData) return false
    if (this.activeText === this.activeBoardData.text) return false
    this.loading = true
    const updateData = {
      updated: new Date(),
      updatedBy: this.uid,
      text: this.activeText,
    }
    await update(infoBoard, this.activeBoard, updateData)
    this.loading = false
    return this.$toast.success(`Board ${this.activeBoardData.name} Successfully Updated.`)
  }

  get activeTab() {
    if (this.$store.state.appStore && this.$store.state.appStore.activeTab) {
      return this.$store.state.appStore.activeTab
    } return null
  }

  @Watch('activeTab', { immediate: true })
  onTabChange(newTab:string) {
    console.log('runing tab change')
    console.log('all boards is: ', this.allBoards)
    const boardList = this.allBoards.filter((board:InfoBoardType) => board.category === newTab)
    console.log('boardlist: ', boardList)
    if (boardList && boardList[0] && boardList[0].id) {
      this.activeBoard = boardList[0].id
      this.activeText = boardList[0].text
    } else this.activeBoard = ''
  }

  async created() {
    if (!this.InfoBoards.bound) {
      await this.InfoBoards.store.dispatch('bindInfoBoards')
      this.InfoBoards.setBound()
    }
    const boardList = this.allBoards.filter((board:InfoBoardType) => board.category === 'daily')
    if (boardList && boardList[0] && boardList[0].id) {
      this.activeBoard = boardList[0].id
      this.activeText = boardList[0].text
    } else this.activeBoard = ''
  }
}

